import { type RoutedNavConfig, ViewName } from '@pressreader/navigation-types';

export const isViewName = (viewNameString: string | undefined): viewNameString is ViewName =>
    viewNameString !== undefined && Object.values(ViewName).indexOf(viewNameString as unknown as ViewName) !== -1;

/**
 * Whether a config the router resolved names a view — all a `RoutedNavConfig` promises. Whether the
 * view registry knows that view is the pipeline's next question, not this one.
 */
export function isRoutedNavConfig(config: unknown): config is RoutedNavConfig {
    const { viewName } = (config ?? {}) as Partial<RoutedNavConfig>;

    return typeof viewName === 'string' && viewName.length > 0;
}
